import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { buscarReservasItinerario } from '../../actions/reserva/buscarReservasItinerario';
import alterarItinerarioFuturo from '../../actions/itinerario/alterarItinerarioFuturo';
import buscarItinerariosFuturo from '../../actions/itinerario/buscarItinerariosFuturo';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import buscarItinerarios from '../../actions/itinerario/buscarItinerarios';
import transferirPassageiro from '../../actions/itinerario/transferirPassageiro';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import determinaPaginaAtual from '../../actions/itinerario/determinarPaginaAtualItinerario';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import BotoesPaginacaoItinerarioParaTransferencia from './BotoesPaginacaoItinerarioParaTransferencia';
import PaginacaoItinerarioParaTransferencia from './PaginacaoItinerarioParaTransferencia';
import { showSuccessMsg } from '../../util/messagesUtil';
import Moment from 'react-moment';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getOperadorRemarcacao } from '../../security/securityContext';
import PainelFiltragem from '../itinerario/PainelFiltrosItinerarioParaTransferencia';

export class ItinerariosParaTransferencia extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itinerarios: [],
            itinerarioSelecionadoParaTransferencia: null,
            retorno: '/painel-transferencia-passageiros'
        }
    }

    UNSAFE_componentWillMount() {
        this.props.determinaPaginaAtual(1)
    }

    getFiltroItinerarioFuturo() {        
        return [{chave: 'isFuturo', valor: 'sim'}, ...this.props.filtrosAdicionados]
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        this.setState({ retorno: `${this.state.retorno}?itinerario=${parametros.itinerario}` })
        if (parametros.itinerario && this.props.reservas.length > 0) {
            this.props.buscarItinerariosFuturo(this.props.empresaSelecionada.id, this.props.itinerarioSelecionado.rotaDto.id, this.props.paginaAtual, this.props.registrosPorPagina, this.getFiltroItinerarioFuturo());
        } else {
            this.props.history.push('/painel-itinerarios');
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparItinerarios();
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarRotas(this.props.empresaSelecionada.id);
                this.props.buscarVeiculos(this.props.empresaSelecionada.id, null, null, null, false);
            }
            this.props.selecionarRota([]);
        }
        if (alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerariosFuturo(this.props.empresaSelecionada.id, this.props.itinerarioSelecionado.rotaDto.id, this.props.paginaAtual, this.props.registrosPorPagina, this.getFiltroItinerarioFuturo());
        }
    }

    buscarItinerariosFuturo() {
        this.props.buscarItinerariosFuturo(this.props.empresaSelecionada.id, this.props.itinerarioSelecionado.rotaDto.id, this.props.paginaAtual, this.props.registrosPorPagina, this.getFiltroItinerarioFuturo());
    }

    selecionarItinerarioFuturo(itinerario) {
        if (itinerario.selecionado) {
            this.setState({ itinerarioSelecionadoParaTransferencia: null });
        } else {
            this.setState({ itinerarioSelecionadoParaTransferencia: itinerario });
        }
        this.props.alterarItinerarioFuturo(itinerario);
    }

    selecionarItinerarioDestino = (itinerarioDestino) => {
        this.setState({
            itinerarioDestinoSelecionado: itinerarioDestino,
        });
    }

    montarParametros() {
        return {
            reservas: this.props.reservas.map(it => it.id),
            codigoEmpresa: this.props.itinerarioSelecionado.idEmpresa,
            itinerarioId: this.state.itinerarioSelecionadoParaTransferencia ? this.state.itinerarioSelecionadoParaTransferencia.id : null,
            itinerarioOrigemId: this.props.itinerarioSelecionado.id
        }
    }

    transferirPassageiros() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        const queryParams = `?itinerario=${parametros.itinerario}`;
        this.props.transferirPassageiro(this.props.itinerarioSelecionado.idEmpresa, this.montarParametros()).then(() => {
            showSuccessMsg('Passageiros transferidos com sucesso!');
            this.props.history.push(`/painel-transferencia-passageiros${queryParams}`);
            setTimeout(() => window.location.reload(), 1000);
        })
    }

    exibeTabelaItinerarios(itinerario) {
        return (
            <div className="geral" key={itinerario.id}>
                <a target="_BLANK" key={itinerario.id} style={{ cursor: 'pointer' }} onClick={() => this.selecionarItinerarioFuturo(itinerario)}>
                    <div className={`${itinerario.selecionado ? 'resumo-laranja' : 'resumo'}`}>
                        <div className="row">
                            <div className="col">
                                <span className="titulo-mobile">Data/Hora saída:&nbsp;</span>
                                <Moment
                                    format="DD/MM/YYYY">{itinerario.dataPartida}</Moment> às {itinerario.horaSaida}
                            </div>
                            <div className="col">
                                <span
                                    className="titulo-mobile">Assentos:&nbsp;</span>{itinerario.assentosDisponiveis}
                            </div>

                            <div className="col mr-md-n2">
                                <span
                                    className="titulo-mobile">Veiculo:&nbsp;</span>{itinerario.veiculoDto.descricao}
                            </div>
                            <div className="col mr-md-4">
                                <span className="titulo-mobile">Rota:&nbsp;</span>
                                {itinerario.rotaDto.cidadeOrigem.nome}-
                                {itinerario.rotaDto.cidadeOrigem.uf} à {itinerario.rotaDto.cidadeDestino.nome}-
                                {itinerario.rotaDto.cidadeDestino.uf}
                            </div>
                            <div className="col mr-md-4">
                                <span className="titulo-mobile">Prestador:&nbsp;</span>
                                {itinerario.prestador ? itinerario.prestador.valor : 'Frota própria'}
                            </div>
                            <div className="col mr-md-3">
                                <div className="botoes">
                                    <span className="titulo-mobile tm-status">Categorias<br />&nbsp;</span>
                                    {itinerario.tipoPreco ? itinerario.tipoPreco.descricaoTipoPreco : itinerario.tipoCategoria}
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        )
    }

    exibeCabecalhoTabela() {
        return (
            <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
                <div className="row cabecalho-desktop">
                    <div className="col">Data/Hora saída</div>
                    <div className="col">Assentos</div>
                    <div className="col">Veículo</div>
                    <div className="col ml-md-2">Rota</div>
                    <div className="col">Prestador</div>
                    <div className="col">Categorias</div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.itinerarioSelecionado.idEmpresa),
                getOperadorRemarcacao(this.props.itinerarioSelecionado.idEmpresa)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <>
                    <Titulo texto="Itinerários para transferência" urlRetorno={this.state.retorno} />
                    {this.props.itinerarios && <div className="col-12 filtro-busca">
                        <PainelFiltragem />
                    </div>}
                    <CabecalhoRodapeTabela
                        OpcoesPaginacao={PaginacaoItinerarioParaTransferencia}
                        BotoesPaginacao={BotoesPaginacaoItinerarioParaTransferencia}
                        itinerarios={this.props.itinerarios}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div>
                            {this.exibeCabecalhoTabela()}
                        </div>
                        <div className="lista-table">
                            {this.props.itinerarios && this.props.itinerarios.map(itinerario => (
                                <div key={itinerario.id}>
                                    {this.exibeTabelaItinerarios(itinerario)}
                                </div>
                            ))}
                        </div>
                    </CabecalhoRodapeTabela>

                    <button className="btn btn-laranja float-right" onClick={() => this.transferirPassageiros()}
                        disabled={this.state.itinerarioSelecionadoParaTransferencia <= 0}>
                        Confirmar
                    </button>
                </>
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        reservas: state.reservasTransferencia,
        itinerarios: state.itinerariosFuturo.itinerarios,
        itinerarioSelecionado: state.itinerarioSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        filtrosAdicionados: state.filtrosAdicionadosItinerario
    }
}

export default connect(mapStateToProps, {
    buscarReservasItinerario,
    buscarItinerariosFuturo,
    buscarItinerarios,
    buscarTiposPreco,
    alterarItinerarioFuturo,
    determinaPaginaAtual,
    transferirPassageiro
})(ItinerariosParaTransferencia);
